"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _settings = require("../settings");
(0, _settings.update)("colors", {
  main: "#e9e9e9",
  primary: "#45ae70"
});
var _default = (0, _settings.get)("colors");
exports["default"] = _default;